'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExperimentEvaluator = exports.EgTnlBucket = undefined;
var _EgTnlBucket = require('./components/EgTnlBucket/EgTnlBucket');
var _EgTnlBucket2 = _interopRequireDefault(_EgTnlBucket);
var _ExperimentEvaluator = require('./components/EgTnlBucket/ExperimentEvaluator');
var _ExperimentEvaluator2 = _interopRequireDefault(_ExperimentEvaluator);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
 **/

exports.EgTnlBucket = _EgTnlBucket2.default;
exports.ExperimentEvaluator = _ExperimentEvaluator2.default;